import { localStorageKeys } from 'storageKeys';

import licensedTourImage from 'assets/start-onboarding-logged-in.png';

import { createTourContext } from '../Tour/createTourContext';

import { LICENSED_TOUR_STEPS, TOUR_DATASET_ID, TOUR_SYSTEM_MODEL, TOUR_VERSION } from './constants';

const {
  useTour: useLicensedTour,
  TourProvider: LicensedTourProvider,
  Tour: LicensedTour,
} = createTourContext({
  name: 'Licensed',
  steps: LICENSED_TOUR_STEPS,
  storageKey: localStorageKeys.LICENSED_TOUR_COMPLETED,
  image: licensedTourImage,
  navigateToStep: (navigate, stepIndex, steps) => {
    const step = steps[stepIndex];
    if (!step?.path) return;

    const basePath = `/${TOUR_VERSION}/${TOUR_SYSTEM_MODEL}`;
    let targetPath: string;

    if (step.path === 'files') {
      targetPath = `${basePath}/files`;
    } else {
      targetPath = `${basePath}/dataset/${TOUR_DATASET_ID}/${step.path}`;
    }

    if (window.location.pathname !== targetPath) {
      navigate(targetPath);
    }
  },
});

export { LicensedTourProvider, useLicensedTour };
export default LicensedTour;
